import * as PIXI from 'pixi.js';

/**
 * Filtering for artwork that is almost always drawn *smaller* than it was
 * authored: the room opens at 0.3 zoom, so a 144 px character frame lands on
 * ~43 screen pixels and a 500 px floor on a fraction of its own size.
 *
 * Two things have to be true or a minified sprite crawls:
 *
 *  - mipmaps, so the sampler reads a level already near 1:1 instead of picking
 *    1 texel in 11 out of the full-resolution image;
 *  - `minFilter: 'linear'`, so *within* that level it averages rather than
 *    point-samples. `nearest` here looks like it should keep pixel art crisp,
 *    but it re-picks which texels survive on every sub-pixel step, and that
 *    flicker is what reads as boiling/heat-haze while the character walks or
 *    the camera pans. Measured on the character at a 390x844 phone viewport:
 *    1.14% -> 0.54% sd of drawn ink across one pixel of travel (4.6% -> 1.9%
 *    peak-to-peak). The old worry that this blurs the Sims-1 read no longer
 *    applies now that the canvas renders at device pixels (SceneManager) --
 *    at devicePixelRatio 2 the artwork lands near 1:1 on the actual screen.
 *
 * The flags are copied into a style object when the texture uploads, so this
 * has to run before the sprite is first drawn; `updateMipmaps` covers the case
 * where it did not.
 */
export function smoothWhenMinified(source?: PIXI.TextureSource | null): void {
  if (!source) return;
  source.autoGenerateMipmaps = true;
  source.magFilter = 'linear'; // zoomed in past 1:1
  source.minFilter = 'linear'; // averaged inside the chosen mip level
  source.mipmapFilter = 'linear'; // no popping between levels
  source.updateMipmaps?.();
}
